export enum ModulesEnum {
  HomeTab = 12,
  AgendaTab = 13,
  AdvisorManagement = 14,
  UserManagement = 15,
  ActivationManagement = 16,
  AgendaManagement = 17,
  LearningTab = 18,
  BrandsTab = 20,
  SellOut = 24,
  Surveys = 25,
  ExecutionManagement = 28,
  Reports = 26,
  AttendanceControl = 27,
  VisualExecution = 29,
  Scorecard = 30,
  SubRetailManagement = 32,
  CourseManagement = 33,
  Metrics = 34,
  Absences = 35,
  AgendaManagementFiles = 36,
  TrainingMaterial = 37,
  ProductsManagement = 38,
  MetricsRealTime = 39,
  MetricsRanking = 40,
  AppointmentControl = 41,
  usersManagementMassive = 42,
  AbsencesMassive = 43,
  AttendanceRoute = 44,
  JustificationAbsences = 45,
  CheckInVsAbsence = 46,
  BulkActivationAssignment = 47,
  Support = 48, // mobile-only
  WebSupport = 50,
  CreateTicket = 51,
  BulkPosManagement = 52,
}
